<template>
  <div class="page home">
    <div class="page__card" v-for="wType in filteredWorkflowTypes" :key="wType.id">
      <div class="page__header">
        <div>
          <h1 class="page__title">
            {{ wType.plural === false ? wType.name : pluralize(wType.name) }}
            <i
              class="fa-solid fa-circle-info fa-xs"
              @click="$modal.show('reportable-conditions')"
              v-if="wType.showInfo"
            />
          </h1>
          <div
            class="page__subtitle"
            v-html="wType.description"
            @click="handleReportableConditionsClick($event, wType)"
          ></div>
        </div>
      </div>
      <div class="items">
        <div class="item panel" v-for="workflow in workflowsByType(wType.id)" :key="workflow.id">
          <h2 class="item__name">
            {{ workflow.title }}
            <span class="note no-spacing" v-if="workflow.read_only">(read only)</span>
          </h2>
          <div class="button-container">
            <themed-button
              :to="{ name: 'new-incident', params: { workflowId: workflow.id } }"
              :disabled="workflow.read_only"
            >
              Start New {{ workflowType({ workflow }) }}
            </themed-button>
            <themed-button :to="{ name: 'incidents', params: { workflowId: workflow.id } }">
              View {{ workflowType({ workflow, plural: true }) }}
            </themed-button>
          </div>
          <div class="item__note" v-html="wType.workflowNote" v-if="wType.workflowNote"></div>
          <div class="item__contacts" v-if="wType.showContactInformation">
            <p>Alternatively, you can contact us via phone or email</p>
            <ul>
              <li v-for="(contact, index) in contactInformation" :key="index">
                {{ contact.label }} <a :href="contact.href">{{ contact.value }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <reportable-conditions />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import ReportableConditions from '@/components/ReportableConditions';

export default {
  name: 'workflows',

  components: { ReportableConditions },

  computed: {
    ...mapState({
      workflows: (state) => state.workflow.workflows,
      workflowTypes: (state) => state.workflow.workflowTypes,
    }),

    filteredWorkflowTypes() {
      return this.workflowTypes.filter((wType) => this.workflowsByType(wType.id).length > 0);
    },

    ...mapGetters(['workflowsByType', 'workflowType', 'contactInformation']),
  },

  methods: {
    handleReportableConditionsClick(event, workflowType) {
      if (!workflowType || !workflowType.showInfo) {
        return;
      }
      const link = event && event.target && event.target.closest
        ? event.target.closest('a.reportable-conditions-link')
        : null;
      if (!link) {
        return;
      }
      event.preventDefault();
      this.$modal.show('reportable-conditions');
    },
  },
};
</script>
